module.exports = __webpack_public_path__ + "img/35-3.2f56508f.jpg";